// extracted by mini-css-extract-plugin
export const container = "_3Mn7lt";